import React from 'react';
import FormLoginBasic from '../Form/FormLoginBasic';
import { TbUserQuestion } from 'react-icons/tb';
import ButtonLoginSSO from './ButtonLoginSSO';
import ButtonClose from '../Form/ButtonClose';
import { useTranslation } from 'react-i18next';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useCartContext } from '../../Contexts/CartContext';

interface LoginBasicProps {
    onClose: CallableFunction;
}

const LoginBasic = ({onClose}: LoginBasicProps) => {

    const { t } = useTranslation();
    const { company } = useLayoutContext();
    const { setReturnToCheckout } = useCartContext();

    const handleClose = () => {
        localStorage.removeItem('redirect');
        setReturnToCheckout(false);
        onClose();
    }

    return (
        <div className="relative grid">
            <ButtonClose onClick={handleClose} fixedOnTop />
            <div className='flex flex-row w-full items-center gap-2 p-3 py-4'>
                <span><TbUserQuestion size={40} className='fadeInIcon' /></span>
                <div className='grid text-left'>
                    <h2 className='text-2xl font-extrabold leading-none'>{t('login.basic.title')}</h2>
                    <p className='text-gray-600 leading-none'>{t('login.basic.subtitle')}</p>
                </div>
            </div>

            {company?.config?.website_authentication_type?.quick_purchase &&
                <FormLoginBasic onCancel={handleClose} />
            }

            {company && company.sso_active &&
                <div className='grid p-4 bg-gray-50 shadow-inner'>
                    <ButtonLoginSSO />
                </div>
            }

        </div>
    )
}

export default LoginBasic;